import axios from 'axios'

const axiosInstance = axios.create()

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) =>
        Promise.reject(
            (error.response && error.response.data) || 'Something went wrong!'
        )
)

export function axiosSetOwnerId(store_id){
    axios.defaults.headers.common = {
        "Ownerid": store_id
       };
       axios.defaults.headers.post['header1'] = 'value'
       //axios.defaults.headers.post['Ownerid']=store_id;

       axios.defaults.headers.post = {
        "Ownerid": store_id
       };
       axiosInstance.defaults.headers.common = {
        "OwneridNew": store_id
       };

       
}

export default axiosInstance
